import {ThumbsDown, ThumbsUp, MessageSquareDashed} from "lucide-react"
import type React from "react"

export interface CommentRate {
    id: number
    title: string
    value: number
    color: string
    icon: React.ReactNode
}

export const commentRates: CommentRate[] = [
    {
        id: 1,
        title: "توصیه میکنم",
        value: 5,
        color: "#FF7745",
        icon: <ThumbsUp/>,
    },
    {
        id: 2,
        title: "مطمئن نیستم",
        value: 3,
        color: "#294580",
        icon: <MessageSquareDashed/>,
    },
    {
        id: 3,
        title: "توصیه نمیکنم",
        value: 1,
        color: "#294580",
        icon: <ThumbsDown/>,
    },
]